"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HighlightURLInText = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _commonConstants = require("../../../../../../../utils/common-constants");

var _constants = require("../constants");

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Component will take a string of text and match URLs
// the matches URLs will be HTML a link elements
// which will open in new tab
// NOTE: Using target="_blank" without rel="noreferrer" is a security risk:
// see https://html.spec.whatwg.org/multipage/links.html#link-type-noopener
var HighlightURLInText = function HighlightURLInText(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text;
  var possibleURLSegments = (0, _utils.extractPossibleURLSegments)(text);
  if (!possibleURLSegments.length) return;
  var urlRegex = /(((www\.)|(https?:\/\/))+[^\s]+)/gi;
  return possibleURLSegments.map(function (possibleURLText) {
    if (possibleURLText && urlRegex.test(possibleURLText) && possibleURLText.search(urlRegex) === 0) {
      return /*#__PURE__*/_react.default.createElement("a", {
        key: possibleURLText,
        className: _constants.classes.linkFieldValue,
        href: // append https:// for URLs like www.abc.com
        possibleURLText.toLowerCase().startsWith("".concat(_commonConstants.www, ".")) ? _commonConstants.httpsProtocol.concat(possibleURLText) : possibleURLText,
        target: "_blank",
        rel: "noreferrer"
      }, possibleURLText);
    } else {
      return possibleURLText;
    }
  });
};

exports.HighlightURLInText = HighlightURLInText;
HighlightURLInText.propTypes = {
  text: _propTypes.default.string
};